<app-action-icon #iconCmp
                 [value]="isThumbset"
                 [state]="state"
                 (toggle)="toggleSetting($event)"
                 class="thumbsup-icon__container"
                 [class.thumbsup-icon__container--active]="isThumbset"
                 [class.thumbsup-icon__container--hover]="iconCmp.hover">
  <mat-icon
    [matTooltip]="tooltip"
    class="thumbsup-icon__icon"
    [class.thumbsup-icon__icon--active]="isThumbset"
    [class.thumbsup-icon__icon--hover]="iconCmp.hover">
    {{icon}}
  </mat-icon>
</app-action-icon>
